var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeviceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3346 6.66536H50.668C55.8226 6.66536 60.0013 10.844 60.0013 15.9987V34.6654C60.0013 39.82 55.8226 43.9987 50.668 43.9987H37.3346H36.0013H28.0013H26.668H13.3346C8.17998 43.9987 4.0013 39.82 4.0013 34.6654V15.9987C4.0013 10.844 8.17998 6.66536 13.3346 6.66536ZM26.668 45.332H13.3346C7.4436 45.332 2.66797 40.5564 2.66797 34.6654V15.9987C2.66797 10.1077 7.4436 5.33203 13.3346 5.33203H50.668C56.559 5.33203 61.3346 10.1077 61.3346 15.9987V34.6654C61.3346 40.5564 56.559 45.332 50.668 45.332H37.3346V57.332H40.0013H41.3346V58.6654H40.0013H37.3346H36.0013H28.0013H26.668H24.0013H22.668V57.332H24.0013H26.668V45.332ZM28.0013 57.332H36.0013V45.332H28.0013V57.332ZM25.3346 14.6654H38.668C40.1407 14.6654 41.3346 15.8593 41.3346 17.332C41.3346 18.8048 40.1407 19.9987 38.668 19.9987H25.3346C23.8619 19.9987 22.668 18.8048 22.668 17.332C22.668 15.8593 23.8619 14.6654 25.3346 14.6654ZM21.3346 17.332C21.3346 15.1229 23.1255 13.332 25.3346 13.332H38.668C40.8771 13.332 42.668 15.1229 42.668 17.332C42.668 19.5412 40.8771 21.332 38.668 21.332H25.3346C23.1255 21.332 21.3346 19.5412 21.3346 17.332Z",
    fill: "#A8927D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceIcon);
export default __webpack_public_path__ + "static/media/device-icon.62afbf3e191d405546c4afc0391050ea.svg";
export { ForwardRef as ReactComponent };